<template>
  <div>

    <v-row>
        <v-col>
            <v-row align="center" justify="center" class="my-3 mx-10">
                <v-col cols="12" sm="5" md="5" xs="5" class="rounded-corners">
                    <v-card class="elevation-12 rounded-corners">
                        <v-toolbar :color="getThemeColor" dark flat>
                            <v-toolbar-title>{{ title }}</v-toolbar-title>
                            <v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <v-text-field label="Email Address" prepend-icon="person"
                                    type="text" placeholder="abc@example.com" v-model="userEmail" />

                                <v-text-field label="New Password" prepend-icon="lock" type="password"
                                    v-model="newPassword" />
    
                              
    
    
    
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded small class="ml-8" :color="getThemeColor" outlined
                                style="margin-right: 20px;margin-bottom: 10px;" @click="routeTo('login')">
                                Go Back
                            </v-btn>
                            <v-spacer />
                            <v-btn rounded dark small class="mr-4" :color="getThemeColor"
                                style="margin-right: 20px;margin-bottom: 10px;" @click="resetPassword()">
                                Reset Password
                            </v-btn>
    
    
    
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from '@/plugins/axios'

export default {
    computed: {
        getThemeColor() {
        return this.$store.getters.getThemeColor
      }  
    },
    mounted() {
        this.$store.commit('setLoader',true)
        if ('email' in this.$route.query) {
            this.userEmail = this.$route.query.email
            this.token = this.$route.query.token

            axios.postData('get-password-reset-token',
                {
                    token: this.token,
                    email: this.userEmail 
                }).then(verified => {
                    if (!verified) {
                        this.$toast.error('Oops, Something went wrong!')
                    this.routeTo('login')
                }
            })
        }
        this.$store.commit('setLoader', false)
    },
    data: () => ({
        userEmail: null,
        newPassword: null,
        token: null,
        title: 'Resetting Password'
    }),
    methods: {
        resetPassword() { 
            axios.postData('/auth/reset-password', {
                email: this.userEmail,
                password: this.newPassword,
                token: this.token
            })
                .then(response => {
                    if (response == 'success') {
                        this.$toast.success('Password successfully reset!')
                        this.routeTo('login')
                    }
                })
        },
        routeTo(pathName) { 
            this.$router.push({name:pathName})
        }
    }

}
</script>
